/**
 * Cart Container
 *
 * Handles hiding/showing/appending to the cart dropdown
 *
 * Events:
 *
 * @subscribes cart-add-product <cart-fragment> <cart-item-id>
 *
 */

var sw = require('./../sw');
var ShapewaysView = require('./ShapewaysView');
var $ = require('js/sw-jquery/sw-jquery');

var Cart = ShapewaysView.extend({

  events: {
    'click [data-sw-cart-close]': 'hide'
  },

  swAttrs: {
    'counter': 'data-sw-cart-counter',
    'modal':   'data-sw-cart-modal',
    'cartList': 'data-sw-cart-list',
    'brandStyle': 'data-sw-cart-brand'
  },

  initialize: function() {
    this.listenTo(sw, 'cart-add-product', this.itemAdded, this);

    this.$cartCounter = this.$(this.swSelectors.counter);
    this.$modal = this.$(this.swSelectors.modal);

    if (!this.$modal.data('swCartModalNoSticky')) {
      this.$modal.sticky({
        topSpacing: 0,
        zIndex: 9999
      });
    }

    if (this.$modal.data('swCartModalTopBorder')) {
      var $topBorder = $(this.$modal.data('swCartModalTopBorder'));
      var bottom = $topBorder.position().top + $topBorder.height();
      this.$modal.css({
        top: (bottom) + 'px'
      });
    }
  },

  itemAdded: function() {

    var requestData = {};
    if (this.$el.attr(this.swAttrs.brandStyle)) {
      requestData.brand = this.$el.attr(this.swAttrs.brandStyle);
    }

    var self = this;
    $.ajax({
      url: '/cart-summary',
      data: requestData,
      success: function(data) {
        self.setCartCount(data.itemCount);
        self.$('[' + self.swAttrs.cartList + ']').replaceWith(data.listFragment);
        self.show();
      },
      type: 'get',
      dataType: 'json'
    });
  },

  getCartCount: function() {
    if (this.$cartCounter.length) {
      return parseInt(this.$cartCounter.html(), 10);
    }

    return 0;
  },

  setCartCount: function(numItems) {
    if (numItems > 0) {
      this.$cartCounter.removeClass('sw--is-hidden');
    }

    if (numItems <= 0) {
      this.$cartCounter.addClass('sw--is-hidden');
    }
    
    this.$cartCounter.html(numItems);
  },

  show: function() {
    this.$el.addClass('open');
    this.$modal.sticky('update');
    sw.trigger('sw-dms-cart-open');
  },

  hide: function() {
    this.$el.removeClass('open');
  }
 
});

module.exports = Cart;
